module.exports = __webpack_public_path__ + "static/media/hc_logo.a2aaa1cb.svg";